import { render, staticRenderFns } from "./HSKForm.vue?vue&type=template&id=2537fb7a&scoped=true&"
import script from "./HSKForm.vue?vue&type=script&lang=js&"
export * from "./HSKForm.vue?vue&type=script&lang=js&"
import style0 from "./HSKForm.vue?vue&type=style&index=0&id=2537fb7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2537fb7a",
  null
  
)

export default component.exports